<div>
  <h6 class="odx-title-6" i18n="@@global.dustExZones">Staub-Ex-Zonen</h6>

  <app-floorplan-menu-item-buttons>
    @for (zoneType of [DustExZoneType.ZONE_20, DustExZoneType.ZONE_21, DustExZoneType.ZONE_22]; track zoneType) {
      <button
        odxButton
        [ngClass]="`dust-ex-background dust-ex-2${$index}`"
        (click)="addDustExZone(zoneType)"
        [odxTooltip]="tooltipTextAddDustExZone($index)"
        [odxTooltipOptions]="{ position: 'bottom-start' }"
        draggable="true"
        (dragstart)="dragDustExZone(zoneType)"
      >
        <odx-icon name="plus" size="medium"></odx-icon>
      </button>
    }
    <app-toggle-visibility-button
      [visible]="floorplanState.dustExZonesVisible"
      (toggleEvent)="floorplanState.dustExZonesVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.dustExZonesItemTextVisible"
      (toggleEvent)="updateDustExZonesItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button [locked]="floorplanState.dustExZonesLocked" (toggleEvent)="floorplanState.dustExZonesLocked = $event">
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
